import { fetchWorkConfig  } from '@/api/homework'

const state = {
  // courseId: '',
  // currentQuestionScore: '', // 当前题目的评分
  // currentQuestionMark: '' // 当前题目的备注
  homeworkStatus: {} // 当前作业状态
}

const mutations = {
  setStatusInfo (state, mark) {
    state.homeworkStatus = mark
  }
}

const actions = {

  fetchWorkConfigInfo ({commit}, data) {
    return new Promise((resolve) => {
      fetchWorkConfig(data).then((res) => {
        commit('setStatusInfo', res)
        resolve(res)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/homeworkEnd.js